export class Dashboard {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "ownerUserId",
            "baseName": "ownerUserId",
            "type": "string",
            "format": ""
        },
        {
            "name": "isShared",
            "baseName": "isShared",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "sessionId",
            "baseName": "sessionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "spec",
            "baseName": "spec",
            "type": "{ [key: string]: any; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Dashboard.attributeTypeMap;
    }
    constructor() {
    }
}
